import { UIPaths } from '../../router/UIPaths';
import appConstants from '../../sp-utils/app.constants';
import appUtils from '../../sp-utils/app.utils';
import notificationConstants from '../../sp-utils/notification-constants';
import TaskService from '../task/TaskService';


const NotificationService = () => {

	const service = {}



	service.getNotificationList = (searchOptions, pagingOptions, sortingOptions, successCB, errorCB) => {
		var options = {
			url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.notification.list,
			data: {
				pageSize: pagingOptions?.pageSize?pagingOptions.pageSize:5,
				pageNumber: pagingOptions?.pageNumber?pagingOptions.pageNumber:1,
				sortByColumnName: '',
				sortByOrder: '',
				statusCodeIDs:searchOptions.statusCodeIDs?searchOptions.statusCodeIDs:null,
				objectTypeCodeIDs: searchOptions.objectTypeCodeIDs?searchOptions.objectTypeCodeIDs:null,
				searchText: ""

			},
		};

		appUtils.callWebService(options, successCB, errorCB);
	}

	service.updateNotificationStatus = (notificationIDList, notificationStatus, successCB, errorCB) => {
		var options = {
			url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.notification.updateStatus,
			data: {
				notificationIDList: notificationIDList,
				statusCodeID: notificationStatus
			}
		};

		appUtils.callWebService(options, successCB, errorCB);
	}

	service.getNotificationProps = (notification) => {
		return notificationConstants[notification.objectTypeCodeID]
	}

	service.parseNotificationData = (data) => {
		let parsedObject = {};

		try {
			parsedObject = data?.object ? JSON.parse(data.object) : {};
		} catch (e) {
			console.error("invalid notification object JSON...", e);
		}

		return {
			notificationID: data.notificationID,
			objectTypeCodeID: Number(data.objectTypeCodeID),
			object: parsedObject,
		};
	};

	service.getNotificationRedirectUrl = (data) => {
    const { objectTypeCodeID } = data;
    switch (objectTypeCodeID) {
      case appConstants.notificationObjectType.task:
        return UIPaths.allTask.detail.replace(
          ":taskNumber",
          data.object.taskNumber
        );

      case appConstants.notificationObjectType.circular:
        return UIPaths.repo.circular.regulatorList

      default:
        return null;
    }
  };

	service.getNotificationProps = (notification) => {
		return notificationConstants[notification.objectTypeCodeID] || {}
	}

	service.getNotificationMetaText = (parsedData) => {
		const { objectTypeCodeID, object } = parsedData

		if (objectTypeCodeID === appConstants.notificationObjectType.task) {
			return object?.taskNumber
				? TaskService.getFormattedTaskNumber(object.taskNumber)
				: null
		}

		if (objectTypeCodeID === appConstants.notificationObjectType.circular) {
			return object?.regulatorCounts
				? Object.entries(object.regulatorCounts)
					.map(([regulator, count]) => `${regulator}: ${count}`)
					.join(', ')
				: null
		}
	}


	return service
}
export default NotificationService()